import PropTypes from 'prop-types';
import {defineMessages} from 'react-intl';

import classNames from 'classnames';

import useCurrentPersona from '@hooks/reduxSession/useCurrentPersona';

import localization from '@services/localization';

const messages = defineMessages({
  orgLogoAlt: {
    id: 'ClientOrganizationLogo.orgLogoAlt',
    defaultMessage: '{orgName} logo',
  },
  clientLogoFallbackAlt: {
    id: 'ClientOrganizationLogo.clientLogoFallbackAlt',
    defaultMessage: 'client logo',
  },
});

const ClientOrganizationLogo = (props) => {
  const {clientLogoUrl, className} = props;
  const {orgName} = useCurrentPersona();
  const altText = orgName
    ? localization.formatMessage(messages.orgLogoAlt, {orgName})
    : localization.formatMessage(messages.clientLogoFallbackAlt);

  return <img src={clientLogoUrl} alt={altText} className={classNames('client-logo-top-bar', className)} />;
};

ClientOrganizationLogo.propTypes = {
  clientLogoUrl: PropTypes.string,
  className: PropTypes.string,
};

export default ClientOrganizationLogo;
